import React, { useEffect, useRef, useState } from "react";
import Modal from "../../atom/modal";
import { set } from "date-fns";
import {
  assignSpareDidstoTenants,
  getAppServerTenants,
  getSpareDids,
} from "../../services/api";
import Notification from "../../atom/Notification";
import { TableSortIconDownArrow } from "../../utils/icons/defaultIcons";
import Table from "../../atom/table";
import FadeIn from "react-fade-in";
import ComponentMap from "../../atom/componentmap";
import { addChildrensToMapData } from "../../services/utilities";
import ThemedButton from "../../atom/ThemedButton/themedButton";
import Loader from "../loader";
import * as loaderLottie from "../../utils/lottie/loaderLottie.json";
import Lottiefy from "../../atom/lottie/lottie";

function AssignNumberModal(props: any) {
  const { setAssignTenantModal, assignTenantModal } = props;
  const [tableData, setTableData] = useState<any>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [assignButtonLoader, setAssignButtonLoader] = useState<boolean>(false);
  const [assignNumberModal, setAssignNumberModal] = useState<boolean>(false);
  const [resultNotFound, setResultNotFound] = useState<boolean>(false);
  const [filteredData, setFilteredData] = useState<any>([]); // filtered table
  const [searchText, setSearchText] = useState<string>("");
  const resRef = useRef<any[]>([]);
  const unselectedRef = useRef<any[]>([]);

  const [tenantList, setTenantList] = useState<any>([
    {
      title: "Select a tenant",
      name: "displayname",
      value: "",
      type: "multiselectdropdown",
      displayProps: {
        label: "displayname",
        value: "displayname",
      },
      childrens: [],
      required: false,
      errormessage: "Select a tenant",
    },
  ]);

  const [tableTitles, setTableTitles] = useState<any>([
    {
      key: "did",
      title: "Number",
      icon: <TableSortIconDownArrow />,
      // sort: { direction: "asc", active: true },
      // classname: "cursor-pointer",
    },

    {
      key: "",
      type: "checkbox",
      classname: "float-right ",
      selectAll: true,
      column_select_hidden: false,
    },
  ]);
  const fetchUnassignedDids = () => {
    setAssignNumberModal(true);
    setLoader(true);

    getSpareDids().then((result: any) => {
      console.log("result", result);
      if (!result.success) {
        Notification(
          "Failed",
          `${result?.message ? result?.message : "Oops! Something went wrong"}`,
          "danger"
        );
        setLoader(false);
        setResultNotFound(true);
      } else {
        setTableData(result?.data?.items);
        setFilteredData(result?.data?.items);
        setLoader(false);
        setResultNotFound(false);
      }
    });
  };
  const fetchTenantsList = () => {
    getAppServerTenants("").then((result: any) => {
      console.log("result", result);
      if (!result.success) {
        Notification(
          "Failed",
          `${result?.message ? result?.message : "Oops! Something went wrong"}`,
          "danger"
        );
      } else {
        // setTenantList(result?.data);
        setTenantList(
          addChildrensToMapData([...tenantList], result?.data, "displayname")
        );
      }
    });
  };
  const onHandleAdd = (data: any) => {
    console.log("data", data);
    if (
      data?.displayname == "" ||
      data?.displayname == null ||
      data?.displayname == undefined
    )
      Notification("Required", "Select any tenant", "danger");
    else fetchUnassignedDids();
  };
  const onHandleClick = (action: string, data: any) => {
    console.log("click", data);
    const clone = [...tableData];
    const ttile = [...tableTitles];
    if (data?.selectAll === true) {
      // const result: any = ttile.find((node: any) => {
      //   return node.key === data.key;
      // });
      // result.checked = !result?.checked || false;
      // clone.map((node: any) => {
      //   node.checked = result?.checked;
      // });
      // setCheckedAll(result.checked);
    } else {
      // setCheckedAll(false);

      const result = clone.find((node: any) => {
        return node.uuid === data.uuid;
      });

      result.checked = !result?.checked || false;
      const matched = tableData?.filter(
        (node: any) => node?.uuid === result.uuid
      );
      if (result?.checked) {
        resRef.current = [...(resRef.current || []), ...matched];
        unselectedRef.current = unselectedRef.current.filter(
          (item: any) => item.uuid !== result.uuid
        );
      } else {
        resRef.current = resRef.current.filter(
          (item: any) => item.uuid !== result.uuid
        );
        unselectedRef.current.push(result);
      }
    }
    const result = clone.find((node: any) => {
      return node?.checked ? node?.checked : false;
    });

    setTableTitles(ttile);
    setTableData(clone);
  };
  const onHandleAssign = () => {
    console.log("tableData", tableData, "teantList", tenantList);
    let tenant_id = tenantList[0]?.value?.uuid;

    setAssignButtonLoader(true);
    const checkedDids = tableData
      ?.filter((node: any) => node?.checked === true)
      .map((item: any) => item?.uuid);
    if (!checkedDids || checkedDids.length === 0) {
      Notification("Required", "Select at least one Number", "danger");
      setAssignButtonLoader(false);
    } else {
      const payload = {
        tenant_id: tenantList[0]?.value?.uuid,
        numbers: checkedDids,
      };
      assignSpareDidstoTenants(payload).then((result: any) => {
        if (!result.success) {
          setAssignButtonLoader(false);
          Notification(
            "Failed",
            `${
              result?.message
                ? result?.message
                : "Oops! Something went wrong. Please try again later"
            }`,
            "danger"
          );
        } else {
          setAssignButtonLoader(false);
          setAssignNumberModal(false);
          setAssignTenantModal(false);
          Notification("Success", "Added successfully", "success");
        }
      });
      console.log("checkedDids", checkedDids);
    }
  };

  const onHandleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.trim();
    setSearchText(value);

    if (!value) {
      setFilteredData(tableData);
      if (tableData?.length === 0) setResultNotFound(true);
      else setResultNotFound(false);
    } else {
      const filtered = tableData.filter((item: any) =>
        item.did?.toString().startsWith(value)
      );

      if (filtered?.length === 0) {
        setResultNotFound(true);
      } else {
        setResultNotFound(false);
      }
      setFilteredData(filtered);
    }
  };

  const actionHandler = (action: string, data: any, key: any) => {
    console.log("action", action, "data", data, "keyy", key);
    const actionsMap: any = {
      rowClick: onHandleClick,
    };
    const act = actionsMap[action];
    if (act) {
      act(action, data, key);
    } else {
      console.log("actionHandler Error");
    }
  };
  useEffect(() => {
    fetchTenantsList();
  }, []);
  return (
    <div className="w-[500px] h-full">
      <Modal
        title={"Assign DID Numbers"}
        closeEvent={() => {
          setAssignTenantModal(false);
        }}
      >
        {loader ? (
          <div className="h-[calc(100vh-380px)] flex justify-center items-center">
            {/* <Loader /> */}
            <Lottiefy loop={true} json={loaderLottie} height={50} width={50} />
          </div>
        ) : (
          <FadeIn>
            {assignNumberModal ? (
              <>
                {/* Search Input */}

                <div className="relative mb-4">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <svg
                      className="w-4 h-4 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 103.5 10.5a7.5 7.5 0 0013.15 6.15z"
                      />
                    </svg>
                  </span>
                  <input
                    type="text"
                    placeholder="Search numbers..."
                    value={searchText}
                    onChange={onHandleSearch}
                    className="w-full pl-10 pr-3 py-2 text-sm border border-gray-300 rounded-lg   focus:outline-none shadow-sm"
                  />
                </div>
                <Table
                  tableTitles={tableTitles}
                  setTableTitles={setTableTitles}
                  // tableData={tableData}
                  // setTableData={setTableData}
                  tableData={filteredData}
                  setTableData={setFilteredData}
                  button={true}
                  buttonIndex={4}
                  buttonText1={"manage"}
                  width={"w-[500px] h-[600px] overflow-auto"}
                  scrollHeight={"h-[calc(100vh-380px)]  overflow-y-auto"}
                  permission={"provision.users.put"}
                  actions={true}
                  actionHandler={actionHandler}
                  resultNotFound={resultNotFound}
                />
                <div className=" h-full py-4 flex  mt-4 float-right">
                  <ThemedButton
                    children={"Cancel"}
                    icon="custom"
                    theme="secondary"
                    // valiData={callReport}
                    // change={setCallReport}
                    click={() => {
                      // setAssignTenantModal(false);
                      setAssignNumberModal(false);
                    }}
                  />
                  <ThemedButton
                    children={"Assign"}
                    icon="custom"
                    theme="primary"
                    click={onHandleAssign}
                    loading={assignButtonLoader}
                    valiData={tenantList}
                    change={setTenantList}
                    // click={onHandleUpdate}
                    // loading={buttonLoader}
                  />
                </div>
              </>
            ) : assignTenantModal ? (
              <>
                <div className="w-[500px] ">
                  <ComponentMap data={tenantList} setData={setTenantList} />
                </div>
                <div className=" h-full py-4 flex  mt-4 float-right">
                  <ThemedButton
                    children={"Cancel"}
                    icon="custom"
                    theme="secondary"
                    // valiData={callReport}
                    // change={setCallReport}
                    click={() => setAssignTenantModal(false)}
                  />
                  <ThemedButton
                    children={"Add"}
                    icon="custom"
                    theme="primary"
                    click={onHandleAdd}
                    // loading={buttonLoader}
                    valiData={tenantList}
                    change={setTenantList}
                    // click={onHandleUpdate}
                    // loading={buttonLoader}
                  />
                </div>
              </>
            ) : null}
          </FadeIn>
        )}
      </Modal>
    </div>
  );
}

export default AssignNumberModal;
